import { useCallback, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { trackPriorities } from 'constants/twilio'
import { _isTeacher } from 'store/selectors/User'

import useVideoContext from '../useVideoContext/useVideoContext'

export default function useLocalVideoToggle() {
    const {
        room: { localParticipant },
        videoTrack,
        getLocalVideoTrack,
        onError,
    } = useVideoContext()
    const [isPublishing, setIspublishing] = useState(false)
    const previousDeviceIdRef = useRef()

    const isTeacher = useSelector(_isTeacher)

    const toggleVideoEnabled = useCallback(() => {
        if (isPublishing) return
        if (videoTrack && localParticipant) {
            previousDeviceIdRef.current = videoTrack.mediaStreamTrack.getSettings().deviceId
            const trackUnpublish = localParticipant.unpublishTrack(videoTrack)
            localParticipant.emit('trackUnpublished', trackUnpublish)
            videoTrack.stop()
        } else {
            setIspublishing(true)
            getLocalVideoTrack({
                name: `camera-${Date.now()}`,
                deviceId: { exact: previousDeviceIdRef.current },
            })
                .then(track =>
                    localParticipant?.publishTrack(track, {
                        priority: isTeacher
                            ? trackPriorities.STANDARD
                            : trackPriorities.LOW,
                    })
                )
                .catch(onError)
                .finally(() => setIspublishing(false))
        }
    }, [
        videoTrack,
        localParticipant,
        getLocalVideoTrack,
        isPublishing,
        onError,
        isTeacher,
    ])

    return [!!videoTrack, toggleVideoEnabled, isPublishing]
}
